export const STORAGE_KEYS = {
  NOTIFICATION_TEMPLATE: (email) => `template:${email}`,
  TOKEN: 'token',
  EMAIL: 'email',
};
Object.freeze(STORAGE_KEYS);
